import { useBilingual } from "@/lib/bilingual";

const ContactMap = () => {
  const b = useBilingual();
  // Google Maps embed centered on Shatian Town, Dongguan City, Guangdong
  const mapSrc =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59452.08!2d113.7800!3d22.7500!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3403f5b0b0b0b0b1%3A0x0!2sShatian%20Town%2C%20Dongguan%2C%20Guangdong%2C%20China!5e0!3m2!1sen!2sus!4v1700000000001";

  return (
    <section className="bg-stone-900">
      {/* Map embed — full width */}
      <div className="w-full" style={{ height: "440px" }}>
        <iframe
          title={b(
            "Forwaro Furniture Factory Location — Shatian Town, Dongguan, Guangdong, China",
            "Forwaro 工廠位置 — 廣東省東莞市沙田鎮民田工業區",
          )}
          src={mapSrc}
          width="100%"
          height="100%"
          style={{ border: 0, display: "block" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* Caption bar */}
      <div className="border-t border-stone-700/50 bg-stone-900">
        <div className="max-w-screen-xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-700/20 text-amber-500 shrink-0">
              <i className="ri-map-pin-2-line text-sm" />
            </div>
            <div>
              <p className="text-stone-200 text-sm font-medium">
                {b(
                  "Min Tian Industrial Zone, Shatian Town, Dongguan City, Guangdong Province, China",
                  "廣東省東莞市沙田鎮民田工業區",
                )}
              </p>
              <p className="text-stone-500 text-xs mt-0.5">
                {b(
                  "廣東省東莞市沙田鎮民田工業區",
                  "Min Tian Industrial Zone · Shatian · Dongguan",
                )}
              </p>
            </div>
          </div>
          <a
            href="https://maps.google.com/?q=Shatian+Town+Dongguan+Guangdong+China"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-stone-600 hover:border-amber-600 text-stone-400 hover:text-amber-400 text-xs font-semibold px-4 py-2 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer shrink-0"
          >
            <i className="ri-external-link-line" />
            {b("Open in Google Maps", "在 Google Maps 開啟")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
